module.exports = __webpack_public_path__ + "img/logo.4aa62c6d.webp";